export default {
  closed: false,
  canInteract: true,
  backgroundImage: '',
  distancingOrder: false,
  version: null,
  isQR: false,
  defaultDeliveryMethod: null,
  language: 'is',
};
